import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { selectors } from "reducers";
import SearchableDropdown from "../../../searchable-dropdown/index";
import { Spinner, Tooltip } from "components/ui";
import { activityCenterStart } from "actions/auto-dialer";
import MdCall from "react-icons/lib/md/phone";
import { IoIosInformation } from "react-icons/lib/io";
import ToggleSwitch from "components/ui/toggle-switch";
import { productLineOptions } from "utils/enum";

const ActivityCenter = ({
  teams,
  user,
  autoDialerEnabled,
  activityCenterStart,
  isFetchingByButton,
  voicemailsAutodialerActive
}) => {
  const useCGMLogic = useSelector(selectors.getUsingCGMLogic);
  
  const [payload, setPayload] = useState({
    userId: user.id,
    team: user.team_id,
    productLine: "CPAP",
    multipleProductLines: false
  });

  const updatePayload = (key, value) => {
    setPayload(prevPayload => ({
      ...prevPayload,
      [key]: value
    }));
  };

  // if (autoDialerEnabled) {
  //   return (
  //     <h1
  //       style={{
  //         textAlign: "center",
  //         color: "red",
  //         fontWeight: "700",
  //         margin: "200"
  //       }}
  //     >
  //       You must stop your autodialer before applying new filters
  //     </h1>
  //   );
  // }
  return (
    <>
      {teams ? (
        <div className="autodialer-filters-container">
          <h1 className="autodialer-filters-title">Activity Center</h1>
          <div className="autodialer-filters-row">
            <div className="autodialer-filters-row-group">
              {/* Teams Dropdown */}
              <div className="autodialer-filters-row-top">
                <label className="autodialer-filters-input-top-label">
                  Teams
                </label>
                <SearchableDropdown
                  options={[
                    { text: "", value: "", key: "" },
                    ...teams.map(({ key, text }) => ({ value: key, text, key }))
                  ]}
                  selected={payload.team}
                  onSelect={value => {
                    updatePayload("team", value);
                  }}
                />
              </div>
              {/* Conditionally Render CGM Logic */}
              {useCGMLogic && (
                <>
                  {/* Eligible Product Line Dropdown */}
                  <div className="autodialer-filters-row-group">
                    <div className="autodialer-filters-row-top">
                      <label className="autodialer-filters-input-top-label">
                        Eligible Product Line
                      </label>
                      <SearchableDropdown
                        options={productLineOptions}
                        selected={payload.productLine}
                        onSelect={value => {
                          updatePayload("productLine", value);
                        }}
                      />
                    </div>

                    <div className="autodialer-filters-row-bottom">
                      <label className="autodialer-filters-input-side-label">
                        Multiple Product Lines
                        <span style={{ paddingLeft: 10 }}>
                          <Tooltip
                            id={"multiple-product-lines"}
                            className="helpful-link-tooltip"
                            effect="solid"
                            message="Include only patients that have multiple assigned product lines"
                          >
                            <IoIosInformation size="16px" />
                          </Tooltip>
                        </span>
                      </label>
                      <div className="autodialer-filters-toggle-right">
                        <ToggleSwitch
                          value={payload.multipleProductLines}
                          onChange={value => {
                            updatePayload("multipleProductLines", value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {payload.team && !autoDialerEnabled && (
            <>
              <button
                className={
                  isFetchingByButton
                    ? "autodialer-filters-start-fetching"
                    : "autodialer-filters-start"
                }
                title={
                  isFetchingByButton ? "Fetching now" : "Start Activity Center"
                }
                onClick={() => {
                  if (!isFetchingByButton) {
                    activityCenterStart(payload);
                  }
                }}
                disabled={voicemailsAutodialerActive}
              >
                <MdCall />
              </button>
              {voicemailsAutodialerActive && (
                <h2
                  style={{
                    textAlign: "center",
                    color: "red",
                    fontWeight: "700"
                  }}
                >
                  Voicemails Tab Is active. Close it to start patients
                  autodialer
                </h2>
              )}
            </>
          )}
        </div>
      ) : (
        <div style={{ textAlign: "center", margin: "50px" }}>
          <Spinner size="45px" />
        </div>
      )}
    </>
  );
};

ActivityCenter.propTypes = {
  teams: PropTypes.arrayOf(PropTypes.object).isRequired,
  user: PropTypes.PropTypes.object.isRequired,
  autoDialerEnabled: PropTypes.bool.isRequired,
  activityCenterStart: PropTypes.func.isRequired,
  isFetchingByButton: PropTypes.bool.isRequired,
  voicemailsAutodialerActive: PropTypes.bool.isRequired
};

export default connect(
  state => ({
    teams: selectors.getTeamNameOptions(state),
    autoDialerEnabled: selectors.getIsAutoDialerEnabled(state),
    isFetchingByButton: selectors.getAutoDialerIsFetchingBatchByButton(state),
    user: selectors.getUser(state),
    voicemailsAutodialerActive: selectors.getAutodialerVoicemailsActive(state)
  }),
  {
    activityCenterStart
  }
)(ActivityCenter);
